import { StateAssert } from '@csp/csp-common-model';
import { isDefined } from '@csp/csp-common-util';
import { isEmpty } from 'lodash';
import {
  ArchiveFileCriteriaFieldsV1,
  ArchiveFileDateRangeFieldsV1,
  ArchiveFileQueryCriterionV1,
  ArchiveFileQueryOperatorV1,
  ArchiveFileQuerySortOrderV1,
  ArchiveFileQueryTypeV1,
  ArchiveFileQueryV1,
  ArchiveFileSortFieldsV1,
} from '@csp/dmdp-api-file-storage-archiving-dto';
import { ArchivingFilesQueryFilter } from '../model/ArchivingFilesQueryFilter';

const byFilter = (
  { criteria, dateRangeCriteria }: ArchivingFilesQueryFilter,
  baseCriterions: ArchiveFileQueryCriterionV1[] = [],
): ArchiveFileQueryV1 => {
  StateAssert.isTrue(!isEmpty(criteria), 'Filter criteria must be set');

  const fieldCriteria: ArchiveFileQueryCriterionV1[] = Object.keys(criteria)
    .map(filterKey => {
      switch (filterKey) {
        case 'fileName':
          return criteria.fileName?.length
            ? {
                fieldCriterion: {
                  field: ArchiveFileCriteriaFieldsV1.FILE_NAME,
                  type: ArchiveFileQueryTypeV1.LIKE,
                  values: [criteria.fileName],
                },
              }
            : undefined;
        default:
          throw new Error(`Invalid filter key: ${filterKey}`);
      }
    })
    .filter(isDefined);

  return {
    dateRangeCriteria:
      dateRangeCriteria.startDate || dateRangeCriteria.endDate
        ? [
            {
              field: ArchiveFileDateRangeFieldsV1.CREATED_AT,
              from: dateRangeCriteria.startDate,
              to: dateRangeCriteria.endDate,
              toInclusive: true,
              fromInclusive: true,
            },
          ]
        : undefined,
    criterion: {
      operator: ArchiveFileQueryOperatorV1.AND,
      criteria: [
        ...baseCriterions,
        ...fieldCriteria,
        {
          fieldCriterion: {
            field: ArchiveFileCriteriaFieldsV1.MIME_TYPE,
            type: ArchiveFileQueryTypeV1.IN,
            values: ['application/pdf', 'text/plain'],
          },
        },
      ],
    },
    sort: [
      {
        field: ArchiveFileSortFieldsV1.FILE_NAME,
        order: ArchiveFileQuerySortOrderV1.ASC,
      },
    ],
  };
};

export const ArchiveFilesQueryMapper = { byFilter };
